import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Contact Us | ShipSticks',
  description:
    'We make golf travel easier, and that includes support. Our friendly customer ' +
    'service team is just a text or call away, any day of the week.',
  alternates: {
    canonical: 'https://www.shipsticks.com/contact',
  },
}

export default metadata
